import React from "react";
import './PaymentDetailsComponent.scss'
import CardComponent from "../../shared/components/card/CardComponent";
import ButtonComponent from "../../shared/components/button/ButtonComponent";
import {CommonService} from "../../shared/services";
import {ImageConfig} from "../../constants"; // Import styles if needed

interface PaymentDetailsComponentProps {
    total: any;
    discount: number | string;
    payableAmount: number | string;
    paymentStatus?: "paid" | "unpaid";
    onPayNowClick: () => void;
    paymentMethod?: string;
    isWaived?: boolean;
    refundAmount?: any;
    enablePay: boolean;
}

const PaymentDetailsComponent = (props: PaymentDetailsComponentProps) => {
    const {
        total,
        refundAmount,
        enablePay,
        isWaived,
        paymentMethod,
        discount,
        payableAmount,
        paymentStatus,
        onPayNowClick
    } = props;

    return (
        <div className="payment-details-wrapper">
            <CardComponent
                title="Payment Details"
                className={`appointment-payment-details-card ${isWaived ? "waived pdd-top-10" : ""}`}
                actions={
                    !isWaived && (paymentStatus === "unpaid" ? (
                        <ButtonComponent
                            color="error"
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                if (!enablePay) {
                                    CommonService._alert.showToast('This appointment has been marked as cancelled or no-show. Payment is not allowed unless the status is updated by the admin.')
                                } else {
                                    onPayNowClick();
                                }
                            }}
                        >
                            Pay Now
                        </ButtonComponent>) : (<><ImageConfig.SuccessIcon/> <span
                        className={"paid-text"}>Paid</span></>))}

            >
                <div className="payment-details__main-section">
                    <div
                        className={paymentStatus === 'paid' ? 'payment-details__info grand-total' : "payment-details__info-paid grand-total"}>
                        <div className="payment-details__info__label">Total Amount (Incl. tax)</div>
                        <div className="payment-details__info__value">
                            ${CommonService.convertToDecimals(payableAmount) || "N/A"}
                        </div>
                    </div>
                </div>

                <div className="payment-details__sub-section-breakup">
                    <div className="payment-details__info gross-total">
                        <div className="payment-details__info__label">Amount</div>
                        <div className="payment-details__info__value">
                            ${CommonService.convertToDecimals(total) || "N/A"}
                        </div>
                    </div>

                    <div className="payment-details__info discount">
                        <div className="payment-details__info__label">Discount</div>
                        <div className="payment-details__info__value green">
                            {discount ? `-$${CommonService.convertToDecimals(discount)}` :
                                <div className="zero-discount">$0.00</div>}
                        </div>
                    </div>
                    {isWaived && <div className="payment-details__info discount">
                        <div className="payment-details__info__label">Refund</div>
                        <div className="payment-details__info__value red">
                            {refundAmount ? `-$${CommonService.convertToDecimals(refundAmount)}` : "N/A"}
                        </div>
                    </div>}

                    <div className="payment-details__separator"/>

                    <div className="payment-details__info net-amount">
                        <div className="payment-details__info__label"><b>Total Amount (Incl. tax)</b></div>
                        <div className="payment-details__info__value">
                            <b>${CommonService.convertToDecimals(payableAmount) || "N/A"}</b>
                        </div>
                    </div>
                    {(paymentStatus === 'paid') && <div className={`payment-details__info net-amount`}>
                        <div className={"payment-details__info__label"}>Payment Method</div>
                        <div className="payment-details__info__value">
                            {isWaived ? "N/A" : CommonService.capitalizeFirstLetterAndRemoveUnderScore(paymentMethod) || "N/A"}
                        </div>
                    </div>}
                </div>
            </CardComponent>
        </div>
    );
};

export default PaymentDetailsComponent;
